import React from 'react';
import ReactDOM from 'react-dom';
import Main from './App';
import { BrowserRouter as Router, Route } from "react-router-dom";
import registerServiceWorker from './registerServiceWorker';

const App = () => (
    <React.Fragment>
        <Router>
            <React.Fragment>
                <Route path="/" component={Main} />
            </React.Fragment>
        </Router>
    </React.Fragment>
);

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js